import { defineMessages } from 'react-intl';

export default defineMessages({
  nullStateMessage: {
    defaultMessage: 'Insufficient data available',
    id: '7k19/z',
    description: 'message that displays when there is no data for the table',
  },
});
